var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"justify-content-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t("lang.label_page_notFound")))])])}
var staticRenderFns = []

export { render, staticRenderFns }